/* This is used to track the position within a list where a user is dragging a file overtop. */

angular.module('am4').directive('indexOnFileDrag', function() {
    return {
        restrict: 'A',
        link: function($scope, $element, $attributes) {
            $element.on('dragenter', function() {
                $scope.$emit('indexOnFileDrag', $scope.$eval($attributes.indexOnFileDrag));
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/indexOnFileDrag.js